import React, { useEffect, useState } from 'react';
import { ListResultsProps } from 'app/area/experience-transfer/list/types-store';
import { mobileWidth } from 'app/area/experience-transfer/list/constants';
import { ListResultsMobile } from 'app/area/experience-transfer/list/components/list-results-mobile';
import { ListResultsDesktop } from 'app/area/experience-transfer/list/components/list-results-desktop';

export const ListResults: React.FC<ListResultsProps> = (props) => {

  const { listItems } = props;
  const [width, setWidth] = useState(window.innerWidth);
  const isMobileView = width < mobileWidth;

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return listItems?.length > 0
    ? (isMobileView ?
      <ListResultsMobile {...props} />
      : <ListResultsDesktop {...props} />)
    : null;
};
